export const setAuthToken = (authToken: string): void =>
	localStorage.setItem('auth_token', authToken);
